import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import { BUSINESS } from "../../config/business";

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const ref = params.get("ref");
  return (
    <div>
      <Header />
      <div className="container py-5 text-center">
        <h2>We've received your payment details</h2>
        <p className="my-3">
          Your booking advance is being confirmed. We'll message you on WhatsApp or call you at{" "}
          {BUSINESS.phone} within a few minutes once it's verified.
        </p>
        {ref && (
          <p className="text-secondary">
            Reference: <strong>{ref}</strong>
          </p>
        )}
        <Link to="/" className="btn btn-primary mt-3">
          Back to home
        </Link>
      </div>
      <Footer />
    </div>
  );
}

export function PaymentFailed() {
  return (
    <div>
      <Header />
      <div className="container py-5 text-center">
        <h2>Payment didn't go through</h2>
        <p className="my-3">
          No amount was deducted, or if it was, it will be auto-refunded by your bank within a few
          days. Please try again, or reach us on WhatsApp at {BUSINESS.whatsapp} and we'll help you
          book directly.
        </p>
        <Link to="/" className="btn btn-primary mt-3">
          Back to home
        </Link>
      </div>
      <Footer />
    </div>
  );
}
